import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { CloseButton, Heading, Paragraph } from '@app/shared/ui/atoms/Common';
import { coinsIcon } from '@app/assets';
import { Page } from '@app/routes';

export function TopSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center relative">
      <CloseButton className="absolute right-0" onClick={() => navigate(Page.COGNITION)} />
      <img src={coinsIcon} alt="coins" className="w-[190px]" />
      <Heading level={2} className="whitespace-pre-line text-center leading-6 text-accent">
        {t('roadmap.title')}
      </Heading>
      <Paragraph className="mb-5 mt-4 text-center font-normal text-[#f0ae4c]">
        {t('roadmap.description')}
      </Paragraph>
    </div>
  );
}
